
import { defineComponent, ref } from "vue";
import ContentTabMenu from "./ContentTabMenu.vue";
import ContentRating from "./ContentRating.vue";
import ContentDoubts from "./ContentDoubts.vue";

export default defineComponent({
  name: "ContentInteraction",
  components: { ContentDoubts, ContentRating, ContentTabMenu },
  setup() {
    const showRating = ref(true);
    const showDoubts = ref(false);

    const setCorrectComponent = (tab: string): void => {
      if (tab === "Avaliações") {
        showRating.value = true;
        showDoubts.value = false;
      }

      if (tab === "Dúvidas") {
        showDoubts.value = true;
        showRating.value = false;
      }
    };

    return {
      showDoubts,
      showRating,
      setCorrectComponent
    };
  }
});
